import { ScheduleDateEntity, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type ScheduleDatePITOptions = ReqChangeId<ScheduleDateEntityOptions>;
export const ScheduleDatePITKey = makePITKey<ScheduleDateEntity>(ScheduleDateEntity.key);
export const ScheduleDatePITDataKey = makePITDataKey<ScheduleDateEntityOptions>(ScheduleDateEntity.dataKey);



// WEBPACK FOOTER //
// ./data/models/ScheduleDatePIT.ts